import React from 'react';
import PropTypes from 'prop-types';

import { Bar } from './ProgressBar.styled';

const ProgressBar = ({
  className,
  dark,
  currentPage,
  totalPages,
  setCurrentPage,
}) => (
  <Bar className={className} dark={dark}>
    <p>
      <span style={{ fontSize: 20 }}>{currentPage || 1}</span>
      <span> / </span>
      <span>{totalPages}</span>
    </p>
    <div className="progress-bar">
      <span
        className="progress-bar--completed"
        style={{ width: `${(currentPage / totalPages) * 100}%` }}
      ></span>
    </div>
    <div className="navigation">
      <button
        type="button"
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <i className="far fa-angle-left" />
        &nbsp;Prev
      </button>
      <button
        type="button"
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next&nbsp;
        <i className="far fa-angle-right" />
      </button>
    </div>
  </Bar>
);

ProgressBar.propTypes = {
  className: PropTypes.string,
  dark: PropTypes.bool,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  setCurrentPage: PropTypes.func,
};

export default ProgressBar;
